// Import model
import { UpdateMessageRequest } from '../models/UpdateMessageRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateMessageRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateMessageRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateMessageRequest instance
   */
  static deserialize(json: string): UpdateMessageRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateMessageRequest instance
   */
  static fromObject(obj: any): UpdateMessageRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateMessageRequest');
    }


    const instance: UpdateMessageRequest = {
      role: obj['Role'] as string | undefined,
      text: obj['Text'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateMessageRequest instances
   */
  static deserializeArray(json: string): UpdateMessageRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateMessageRequest instance to a JSON string
   */
  static serialize(instance: UpdateMessageRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateMessageRequest instance to a plain object
   */
  static toObject(instance: UpdateMessageRequest): any {
    return {
      'Role': instance.role,
      'Text': instance.text,
      'ContentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of UpdateMessageRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateMessageRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
